import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { Time } from "components/Form/components/Time/Time";

export const TimeFormComponent = ({ input, meta, fieldProps, fieldAttr }: FormComponentProps) => {
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <Time identifier={input?.name} input={input} fieldAttr={fieldAttr} />
        </Input>
    );
};
